// extracted by mini-css-extract-plugin
export default {"limitBox":"fileUpload_limitBox__71fQP"};